// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"N1-z","subtitle":"O1-z","wrapper":"P1-z","leftArrow":"Q1-z","rightArrow":"R1-z"};